module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/rectangleConversionS_VA.79595b22.svg";